export default __webpack_public_path__ + "static/media/right paper.53b43086.png";